import React from 'react';
import Lot from "./components/Lot"
function view(props) { 
    return (
        <div style={{marginTop:50}}>
          
         
          <Lot />
        </div>
    );
}

export default view;